import React from 'react';
import { Label } from '../Label';
export const CouponLabel = ({ discount }) => (React.createElement(Label, { icon: "TagOutlined", backgroundColor: "red800", letterSpacing: "normal", borderRadius: "2px", padding: "small" },
    "-",
    discount,
    " \u20AC"));
